export const LABELS = {
  FIX_PRICE: "Fix price per tenant",
  PERCENT_SPACE: "% of rental space",
  BY_AREA: "Based on occupied sqft",
  NUMBER_TENANTS: "Based on number of tenants",
  NUMBER_ROOMS: "Based on number of rooms",
  UNKNOWN: "I don't know",
  NOTHING: "No charge",
  PERCENT: "% of rental space",
};
